import { Loader } from 'braid-design-system';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import { useLogin } from '#src/hooks/auth.tsx';

export const ResetSessionPage = () => {
  const [searchParams] = useSearchParams();
  const { login } = useLogin();
  useEffect(() => {
    const organization = searchParams.get('org');
    login({
      ...(organization ? { organization } : {}),
      returnTo: '/manage',
      includeQueryParams: false, // Do not include query params in the returnTo as it can cause infinite login loop
    });
  }, [searchParams, login]);

  return (
    <BasePage title="Resetting session" breadcrumbs={null}>
      <Loader />
    </BasePage>
  );
};
